import { Plant } from '../types/plant';
import api from '../api/axios';
import { decryptData } from '../utils/decrypt';

export const getAllPlants = async (): Promise<Plant[]> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/plants`);
    if (response.status !== 200) throw new Error('Error fetching roles');
      const decrypted = decryptData(response.data, response.data.iv);
      return decrypted;
    // return response.data;
  } catch (error) {
    console.error('Error fetching all plants:', error);
    throw error;
  }
};
